import React, { Component, Fragment } from 'react';
import * as d3 from 'd3'
import "./pie-chart.css";
import {getColor} from "../../utilities/getColor";


function arcTween(oldData, newData, arc) {
  const copy = { ...oldData };
  return function() {
    const interpolateStartAngle = d3.interpolate(
      oldData.startAngle,
      newData.startAngle
      ),
      interpolateEndAngle = d3.interpolate(
        oldData.endAngle,
        newData.endAngle
      );

    return function(t) {
      copy.startAngle = interpolateStartAngle(t);
      copy.endAngle = interpolateEndAngle(t);
      return arc(copy);
    };
  };
}


class Arc extends Component {

  d = d3.arc()
    .outerRadius(100)
    .innerRadius(80);

  componentDidMount() {
    d3.select(this.refs.path)
      .transition()
      .duration(300)
      .attrTween("d", arcTween({startAngle: 0, endAngle: 0}, this.props.d, this.d))
  }


  componentWillReceiveProps(nextProps) {
    d3.select(this.refs.path)
      .transition()
      .duration(300)
      .attrTween("d", arcTween(this.props.d, nextProps.d, this.d))
  }


  render() {
    return (
      <path
        d={this.d(this.props.d)}
        fill={this.props.color}
        ref="path"
      />
    )
  }
}


class PieChart extends Component {

  state = {
    data: []
  };

  colors = ['yellow', 'blue', 'red', "steelblue", "white", "black", "gainsboro"];

  pie = d3.pie()
    .sort(null)
    .value(function(d) { return d; });


  // componentDidMount() {
  //   this.setState({
  //     data: [1,2,3]
  //   })
  // }

  render() {
    console.log(this.pie(this.state.data), 'pie');
    return (
      <div style={{height: '800px'}}>
        <div>
      <svg width="300" height="300" transform="translate(100, 50)" >
        <g transform="translate(100, 120)"  ref="g">
        {
            this.pie(this.state.data).map((d, i) => (
              <Arc
                key={i}
                d={d}
                color={this.colors[i]}
              />
            ))
        }
        </g>
      </svg>
        </div>
      <button onClick={() => this.setState({
        data: [Math.random(),Math.random(),Math.random(), Math.random(),Math.random(),Math.random()]
      })}>Change state</button>
      </div>
    )
  }
}


export default PieChart


// WEBPACK FOOTER //
// ./src/components/pie-chart-2/pie-chart-component.js